import { Pipe, PipeTransform, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'removeHtmlTag',
})
export class RemoveHtmlTagPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}
  transform(value: string): any {
    value = value.split('</div>').join(' </div>');
    var span = document.createElement('span');
    span.innerHTML = value;
    return span.textContent || span.innerText;
  }
}
